(function () {
    'use strict';

    angular.module('Services').factory('CarrierLoadRatesTableService', CarrierLoadRatesTableService);

    CarrierLoadRatesTableService.$inject = [
        'Carrier',
        'TableLiteFactory',
        '$uibModal',
        'toastr',
        'Units',
        '$rootScope'
    ];

    function CarrierLoadRatesTableService(
        Carrier,
        TableLiteFactory,
        $uibModal,
        toastr,
        Units,
        $rootScope
    ) {
        return function (serviceProfile, options) {
            let onUpdateRecord = null;
            const isWeightBased = options.rateType.value.toLowerCase() === 'byweight' ? 'ByWeight' : false;
            const isItemBased = options.rateType.value.toLowerCase() === 'bypallet' ? 'ByPallet' : false;
            const isDistanceBased = options.rateType.value.toLowerCase() === 'bydistance' ? 'ByDistance' : false;
            const isTimeBased = options.rateType.value.toLowerCase() === 'bytime' ? 'ByTime' : false;
            const isVolumeBased = options.rateType.value.toLowerCase() === 'byvolume' ? 'ByVolume' : false;

            let rateCard = null;
            let headers = serviceProfile.service.rateCategories.find(rateType => {
                return rateType.value === options.rateType.value
            }).categories;

            // if(isWeightBased) {
            //     headers.splice(3, 1, 'weightIncrement', 'minItemWeight', 'maxItemWeight');
            // }
            
            let transitTimeHeaders = ['transitTimeEarliest', 'transitTimeLatest'];

            const headerFormat = options && (options.isDraft || options.isPreview) ?
                ['zoneFrom', 'zoneTo', ...headers, ...transitTimeHeaders, 'reciprocalAllowed',] :
                ['checkbox', 'zoneFrom', 'zoneTo', ...headers, ...transitTimeHeaders, 'reciprocalAllowed'];
            const rateTypes = serviceProfile.service.rateCategories.map(rateType => {
                if (rateType.value.toLowerCase() === 'bypallet') {
                    const palletCategories = [
                        'secondItemOnwardsIncrementAmount',
                        'minDeadWeight',
                        'maxDeadWeight',
                        'minLength',
                        'maxLength',
                        'minWidth',
                        'maxWidth',
                        'minHeight',
                        'maxHeight',
                        'minCubicWeight',
                        'maxCubicWeight'
                    ];
                    palletCategories.forEach(cat => rateType.categories.push(cat));
                }
               

                // if (rateType.value.toLowerCase() === 'byweight') {
                //     const byWeightCategories= [
                //         'minLength',
                //         'maxLength',
                //         'minWidth',
                //         'maxWidth',
                //         'minHeight',
                //         'maxHeight',
                //     ];
                //     byWeightCategories.forEach(cat => rateType.categories.push(cat));
                // }

                return rateType;
            });
            const HEADERS = {
                zoneFrom: {
                    label: 'Zone Origin', //header name
                    viewName: 'zoneOrigin', //Attribute name on what to display from data
                    filterName: 'zoneFrom.name',
                    headerFn: function () {
                        sort(this.filterName);
                    },//Use for sorting
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    }
                },
                zoneTo: {
                    label: 'Zone Destination', //header name
                    viewName: 'zoneDestination', //Attribute name on what to display from data
                    filterName: 'zoneTo.name',
                    headerFn: function () {
                        sort(this.filterName);
                    },//Use for sorting
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    }
                },
                basic: {
                    label: 'Basic', //header name
                    viewName: 'basicFormatted', //Attribute name on what to display from data
                    filterName: 'basic',
                    class: 'text-right',
                    headerFn: function () {
                        sort(this.filterName);
                    },//Use for sorting
                    /*filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            //    sendRequest(evaluateFilter(header));
                        }
                    }*/
                },
                minimum: {
                    label: 'Minimum', //header name
                    viewName: 'minimumFormatted',
                    filterName: 'minimum',//Attribute name on what to display from data
                    class: 'text-right',
                    headerFn: function () {
                        sort(this.filterName);
                    },//Use for sorting
                    /*filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            //    sendRequest(evaluateFilter(header));
                        }
                    }*/
                },
                perKgRate: {
                    label: 'Rate Per KG Price', //header name
                    viewName: 'perKgRateFormatted', //Attribute name on what to display from data
                    class: 'text-right',
                    filterName: 'ratePerKg',
                    headerFn: function () {
                        sort(this.filterName);
                    },//Use for sorting
                    /*filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            //    sendRequest(evaluateFilter(header));
                        }
                    }*/
                },
                weightOffset: {
                    label: 'Weight Offset',
                    viewName: 'weightOffsetFormatted',
                    class: 'text-right',
                    filterName: 'weightOffset',
                    headerFn: function () {
                        sort(this.filterName);
                    },
                },
                weightIncrement: {
                    label: 'Weight Increment',
                    viewName: 'weightIncrement',
                    class: 'text-right',
                    headerFn: function() {
                        sort(this.filterName);
                    }
                },
                perVolumeRate: {
                    label: 'Volume Per Rate',
                    viewName: 'perVolumeRate',
                    filterName: 'perVolumeRate',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                roundDecimalToNearestVolume: {
                    label: 'Round Decimal To The Nearest Volume',
                    viewName: 'roundDecimalToNearestVolume',
                    filterName: 'roundDecimalToNearestVolume',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                volumeOffset:{
                    label: 'Volume Offset',
                    viewName: 'volumeOffset',
                    filterName: 'volumeOffset',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                measureUnit: {
                    label: 'Measure UNIT',
                    viewName: 'measureUnit',
                    filterName: 'measureUnit',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                transitTimeEarliest: {
                    label: 'Transit Time Earliest', //header name
                    viewName: 'transitTimeEarliestFormatted', //Attribute name on what to display from data
                    filterName: 'transitTimeEarliest',
                    headerFn: function () {
                        sort(this.filterName);
                    },//Use for sorting
                    /*filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            //    sendRequest(evaluateFilter(header));
                        }
                    }*/
                },
                transitTimeLatest: {
                    label: 'Transit Time Latest', //header name
                    viewName: 'transitTimeLatestFormatted', //Attribute name on what to display from data
                    filterName: 'transitTimeLatest',
                    headerFn: function () {
                        sort(this.filterName);
                    },
                    /*filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            //    sendRequest(evaluateFilter(header));
                        }
                    }*/
                },
                rate3Kg: {
                    label: 'Rate Per 3kg', //header name
                    viewName: 'rate3kgFormatted', //Attribute name on what to display from data
                    class: 'text-right',
                    filterName: 'rate3kg',
                    headerFn: function () {
                        sort(this.filterName);
                    },
                    /*filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            //    sendRequest(evaluateFilter(header));
                        }
                    }*/
                },
                rate5Kg: {
                    label: 'Rate Per 5kg', //header name
                    viewName: 'rate5kgFormatted',
                    filterName: 'rate5kg',//Attribute name on what to display from data
                    class: 'text-right',
                    headerFn: function () {
                        sort(this.filterName);
                    },
                },
                rateOver5Kg: {
                    label: 'Rate Over 5kg', //header name
                    viewName: 'rateOver5kgFormatted', //Attribute name on what to display from data
                    class: 'text-right',
                    filterName: 'rateOver5kg',
                    headerFn: function () {
                        sort(this.filterName);
                    },
                },
                packageType: {
                    label: 'Package Type',
                    viewName: 'packageTypeFormatted',
                    filterName: 'packageType',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                secondItemOnwardsIncrementAmount: {
                    label: '2nd Item Onwards Increment Amount',
                    filterName: 'secondItemOnwardsIncrementAmount',
                    viewName: 'secondItemOnwardsIncrementAmount',
                    class: 'text-right',
                    headerFn: function() {
                        sort(this.filterName);
                    }
                },
                minQuantity: {
                    label: 'Min Qty',
                    viewName: 'minQuantity',
                    filterName: 'minQuantity',
                    headerFn: function () {
                        sort(this.filterName);
                    },
                },
                maxQuantity: {
                    label: 'Max Qty',
                    viewName: 'maxQuantity',
                    filterName: 'maxQuantity',
                    headerFn: function () {
                        sort(this.filterName);
                    },
                },
                action: {
                    label: 'ACTION', //header name
                    viewName: 'action', //Attribute name on what to display from data
                    headerFn: function () {
                        sort(this.filterName);
                    },
                },
                reciprocalAllowed: {
                    label: 'Reciprocal Allowed', //header name
                    viewName: 'reciprocalAllowed', //Attribute name on what to display from data
                    filterName: 'reciprocal',
                    headerFn: function () {
                        sort(this.filterName);
                    },
                },
                checkbox: {
                    label: 'Select',
                    class: 'text-center',
                    filter: {
                        type: 'checkbox'
                    }
                },
                minDeadWeight: {
                    label: 'Min Dead Weight',
                    viewName: 'minDeadWeight',
                    filterName: 'minDeadWeight'
                },
                maxDeadWeight: {
                    label: 'Max Dead Weight',
                    viewName: 'maxDeadWeight',
                    filterName: 'maxDeadWeight'
                },
                minLength: {
                    label: 'Min Length',
                    viewName: 'minLength',
                    filterName: 'minLength'
                },
                maxLength: {
                    label: 'Max Length',
                    viewName: 'maxLength',
                    filterName: 'maxLength'
                },
                minWidth: {
                    label: 'Min Width',
                    viewName: 'minWidth',
                    filterName: 'minWidth'
                },
                maxWidth: {
                    label: 'Max Width',
                    viewName: 'maxWidth',
                    filterName: 'maxWidth'
                },
                minHeight: {
                    label: 'Min Heigth',
                    viewName: 'minHeight',
                    filterName: 'minHeight'
                },
                maxHeight: {
                    label: 'Max Heigth',
                    viewName: 'maxHeight',
                    filterName: 'maxHeight'
                },
                minCubicWeight: {
                    label: 'Min Cubic Volume',
                    viewName: 'minCubicWeight',
                    filterName: 'minCubicWeight'
                },
                maxCubicWeight: {
                    label: 'Max Cubic Volume',
                    viewName: 'maxCubicWeight',
                    filterName: 'maxCubicWeight'
                },
                cubicConversion: {
                    label: 'Cubic conversion',
                    viewName: 'cubicConversion',
                    filterName: 'cubicConversion',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                reference:{
                    label: 'Reference',
                    viewName:'reference',
                    filterName: 'reference',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                itemValue: {
                    label: 'Value',
                    filterName: 'itemValue',
                    viewName: 'valueFormatted',
                    class: 'text-right',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                ratePerKm: {
                    label: 'Rate Per Kilometer',
                    viewName: 'ratePerKm',
                    filterName: 'ratePerKm',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                tailGateHourlyRate: {
                    label: 'Tail Gate Hourly Rate',
                    viewName: 'hourlyRate',
                    filterName: 'hourlyRate',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                hourlyRate: {
                    label: 'Hourly Rate',
                    viewName: 'hourlyRate',
                    filterName: 'hourlyRate',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                minDuration: {
                    label: 'Min Duration',
                    viewName: 'minDuration',
                    filterName: 'minDuration',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                maxDuration: {
                    label: 'Max Duration',
                    viewName: 'maxDuration',
                    filterName: 'maxDuration',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                minVariance: {
                    label: 'Min Variance',
                    viewName: 'minVariance',
                    filterName: 'minVariance',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                maxVariance: {
                    label: 'Max Variance',
                    viewName: 'maxVariance',
                    filterName: 'maxVariance',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                minRate: {
                    label: 'Min Rate',
                    viewName: 'minRate',
                    filterName: 'minRate',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                maxRate: {
                    label: 'Max Rate',
                    viewName: 'maxRate',
                    filterName: 'maxRate',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                minItemWeight: {
                    label: 'Min Item Weight',
                    viewName: 'minItemWeightFormatted',
                    filterName: 'minItemWeight',
                    headerFn: function() {
                        sort(this.filterName);
                    }
                },
                maxItemWeight: {
                    label: 'Max Item Weight',
                    viewName: 'maxItemWeightFormatted',
                    filterName: 'maxItemWeight',
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }
            };
            var tableStructure = {
                config: {
                    noTopOptions: false,
                    noFooter: false,
                    rowsUnclickable: false,
                    colMinWidth: '100px',
                    tableHeight: options.fixedHeight ? '200px' : '',
                },
                optionAddOns: {
                    buttons: options && (options.isDraft || options.isPreview) ? null : [{
                        class: 'btn-primary',
                        label: 'Add new +',
                        tooltip: 'Click to add new rate',
                        onClick: function () {
                            openRateModal();
                        }
                    }, {
                        class: 'btn-primary',
                        label: 'Preview',
                        tooltip: 'Click to preview details',
                        onClick: function () {
                            previewRateCard(angular.copy(tableStructure.data))
                        }
                    }, {
                        class: 'btn-success',
                        label: 'Allow Reciprocal',
                        tooltip: 'Click to allow reciprocal',
                        onClick: function () {
                            const selectedIds = tableStructure.data.filter(item => item.isSelected).map(item => item.id);
                            Carrier.enableReciprocal(selectedIds, data => {
                                toastr.success('Successfully enabled reciprocals on selected rates');
                                sendRequest();
                            }, error => {
                                toastr.error('Unable to activate reciprocals on selected rates', error.message);
                            }, serviceProfile.id);
                        },
                        hide: function () {
                            return !tableStructure.data.find(item => {
                                return item.isSelected
                            });
                        }
                    }, {
                        class: 'btn-success',
                        label: 'Deny Reciprocal',
                        tooltip: 'Click to deny reciprocal',
                        onClick: function () {
                            const selectedIds = tableStructure.data.filter(item => item.isSelected).map(item => item.id);
                            Carrier.disableReciprocal(selectedIds, data => {
                                toastr.success('Reciprocals on selected rates disabled');
                                sendRequest();
                            }, error => {
                                toastr.error('Unable to deactivate reciprocals on selected rates', error.message);
                            }, serviceProfile.id);
                        },
                        hide: function () {
                            return !tableStructure.data.find(item => {
                                return item.isSelected
                            });
                        }
                    }, {
                        class: 'btn-success',
                        label: 'Import CSV file',
                        tooltip: 'Click to Import data from CSV file',
                        onClick: function () {
                            openImportCSVModal();
                        }
                    },{
                        class: 'btn-success',
                        label: 'Export CSV file',
                        tooltip: 'Click to Export data from CSV file',
                        onClick: function () {
                            exportCSVFile();
                        }
                    },{
                        class: 'btn-danger',
                        label: 'Delete',
                        tooltip: 'Click to Export data from CSV file',
                        onClick: function () {
                            deleteRate();
                        },
                        hide: function () {
                            return !tableStructure.data.find(item => {
                                return item.isSelected
                            });
                        }
                    }
                    ]
                },
                headers: headerFormat.map(header => HEADERS[header]),
                data: [],
                rowOnClick: options && (options.isDraft || options.isPreview) ? null : function (rate) {
                    openRateModal(rate);
                }
            };
            const tableActions = new TableLiteFactory(tableStructure,
                {
                    serviceCallback: Carrier.getServiceRateCards,
                    callbackFormat: ['id', 'success', 'error', 'filter'],
                    postRequestCallback: data => {
                        rateCard = angular.extend({ content: data }, serviceProfile);
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: {
                        size: 20,
                        page: 0,
                        sort: 'id,desc',
                        draft: !!options && !!options.isDraft,
                        rateType: isWeightBased || isItemBased || isDistanceBased || isTimeBased || isVolumeBased
                    },
                    paramId: serviceProfile.id
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function openRateModal(rate) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    windowClass: 'full-height-modal',
                    templateUrl: '/templates/pages/carriers/additionals/rateCardDetailsModal.html',
                    controller: 'rateCardDetailsModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    backdrop: 'static',
                    appendTo: $('body'),
                    resolve: {
                        serviceProfile: function () {
                            return angular.extend(serviceProfile, { rateTypes });
                        },
                        rateDetails: function () {
                            console.log(rate);
                            const serviceRate = rate || {};
                            return angular.extend(serviceRate, { type: rateTypes.find(type => type.value === options.rateType.value) });
                        }
                    }
                });
                modalInstance.result.then(function (data) {
                    onUpdateRecord(data);
                }, function () {
                });

                //call add API after save
                //refresh table data after save
            }
            function deleteRate(){
                const selectedIds = tableStructure.data.filter(item => item.isSelected).map(item => item.id);
                const payload={
                    serviceProfileId: serviceProfile.id,
                    rateIds:selectedIds
                }
                Carrier.deleteSelectedRateCard(payload, data => {
                    toastr.success('Rate deleted');
                    tableActions.sendRequest({})
                }, err => {
                    toastr.error('Error on deleting rate', err.message);
                });
            }
            function exportCSVFile() {
                const rateType = getRateType();
                const serviceProfileId = serviceProfile.id;
                Carrier.exportRates(serviceProfileId, rateType, success => {
                    toastr.success('Success!', 'Rate successfully exported')
                }, error => {
                    toastr.error('Error!', error.message);
                });
            }

            function getRateType() {
                if (isWeightBased) {
                    return isWeightBased;
                }

                if (isItemBased) {
                    return isItemBased;
                }

                if (isDistanceBased) {
                    return isDistanceBased;
                }

                if (isTimeBased) {
                    return isTimeBased;
                }

                return null;
            }

            function openImportCSVModal() {
                var modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    windowClass: 'full-height-modal',
                    templateUrl: '/templates/pages/carriers/additionals/importRatesModal.html',
                    controller: 'ImportRatesCsvController',
                    controllerAs: 'vm',
                    size: 'md',
                    appendTo: $('body'),
                    resolve: {
                        tableHeaders: function () {
                            return rateTypes.map(type => {
                                return angular.extend(type, {
                                    tableHeaders: [...type.categories.map(header => {
                                        return HEADERS[header]
                                    }), HEADERS.reciprocalAllowed]
                                });
                            });
                        },
                        serviceProfile: () => {
                            return serviceProfile;
                        },
                        importOptions: function () {
                            return options
                        }
                    }

                });
                modalInstance.result.then(function (data) {
                    //sendRequest({});
                    onUpdateRecord(data);
                }, function () {
                    //sendRequest({});
                    onUpdateRecord();
                });
            }

            function buildTableData(data, pagination) {
                let unit ;
                if($rootScope.GlobalProfile.office.weightUnit==='pounds'){
                    unit = 'LBS';
                }
                if($rootScope.GlobalProfile.office.weightUnit==='kilograms'){
                    unit = 'KG';
                }
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (row, index) {
                    const latestTimeFormat = new hrsFormats(row.transitTimeLatest);
                    const earliestTimeFormat = new hrsFormats(row.transitTimeEarliest);
                    //row.href = '/carriers/service-profile/view/' + row.id;
                    tableStructure.data.push(angular.extend(row, {
                        action: {
                            type: 'button',
                            buttons: [{
                                text: 'Edit',
                                class: 'btn btn-primary',
                                action: (row) => {
                                    alert('edit mode');
                                }
                            }, {
                                text: 'Delete',
                                class: 'btn btn-danger',
                                action: (row) => {
                                    alert('deleted')
                                }
                            }]
                        },
                        zoneOrigin: row.zoneFrom.name + ' (' + row.zoneFrom.code + ')',
                        zoneDestination: row.zoneTo.name + ' (' + row.zoneTo.code + ')',
                        transitTimeLatestFormatted: latestTimeFormat.string,
                        transitTimeEarliestFormatted: earliestTimeFormat.string,

                        rate3kgFormatted: row.rate3kg ? row.rate3kg + ' ' + (serviceProfile.currency || 'AUD') : 'N/A',
                        rate5kgFormatted: row.rate5kg ? row.rate5kg + ' ' + (serviceProfile.currency || 'AUD') : 'N/A',
                        rateOver5kgFormatted: row.rateOver5kg ? row.rateOver5kg + ' ' + (serviceProfile.currency || 'AUD') : 'N/A',
                        weightOffsetFormatted: row.weightOffset ?
                        row.weightOffset + ' ' + Units.getWeightUnit($rootScope.GlobalProfile.office.weightUnit) : '0',
                        weightIncrement: row.weightIncrement ? `${row.weightIncrement} ${unit}` : '0',
                        minItemWeightFormatted: row.minItemWeight ? `${row.minItemWeight} ${unit} ` : '0',
                        maxItemWeightFormatted: row.maxItemWeight ? `${row.maxItemWeight} ${unit}` : '0',

                        perKgRateFormatted: computeValue(row.ratePerKg),
                        basicFormatted: computeValue(row.basic),
                        minimumFormatted: computeValue(row.minimum),
                        valueFormatted: computeValue(row.itemValue),

                        transitTimeLatestHrs: latestTimeFormat.hrs,
                        transitTimeLatestD: latestTimeFormat.days,
                        transitTimeLatestW: latestTimeFormat.weeks,
                        transitTimeEarliestHrs: earliestTimeFormat.hrs,
                        transitTimeEarliestD: earliestTimeFormat.days,
                        transitTimeEarliestW: earliestTimeFormat.weeks,
                        perKgRate: row.ratePerKg,
                        reciprocalAllowed: row.reciprocal ? 'Yes' : 'No',
                        packageTypeFormatted: row.packageType ? row.packageType.charAt(0).toUpperCase() + row.packageType.slice(1) : 'Pallet',
                        
                        minLength: row.minLength ? row.minLength :'0',
                        maxLength: row.maxLength ? row.maxLength :'0',
                        minWidth: row.minWidth ? row.minWidth :'0',
                        maxWidth: row.maxWidth ? row.maxWidth:'0',
                        minHeight: row.minHeight ? row.minHeight:'0',
                        maxHeight: row.maxHeight ? row.maxHeight :'0'
                        
                    }));

                });
                /*** END - Building of Data ***/
              
            }

            function computeValue(value) {
                if (options.margin) {
                    let margin = options.margin;
                    let fuel = serviceProfile.fuelLevy.details;
                    let fuelComputed = 0;
                    let marginComputed = (value + margin.fixed) * (1 + margin.percent / 100) - value;

                    if (serviceProfile.fuelLevy.enabled) {
                        fuelComputed = fuel !== null ? (value + fuel.fixed) * (1 + fuel.percentage / 100) - value : 0;
                    }

                    value += marginComputed + fuelComputed;
                    return `${value.toFixed(2)} ${serviceProfile.currency || 'AUD'}`;
                }
                return `${value || 0} ${serviceProfile.currency || 'AUD'}`;
            }

            function previewRateCard(data) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    windowClass: 'full-height-modal',
                    templateUrl: '/templates/pages/carriers/RateCardPrevModal.html',
                    controller: 'RateCardPrevModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    appendTo: $('body'),
                    resolve: {
                        selected: function () {
                            return angular.copy(data);
                        },
                        serviceRate: function () {
                            return angular.copy(serviceProfile);
                        },
                        rateType: function () {
                            return angular.copy(options.rateType);
                        },
                        headers: function () {
                            return angular.copy(tableStructure.headers);
                        }
                    }
                });

                modalInstance.result.then(function (data) {
                }, function () {
                });
            }

            function hrsFormats(hrs) {
                const totalDays = Math.floor(hrs / 24);
                const weeks = Math.floor(totalDays / 7);
                const days = totalDays % 7;
                const remHrs = hrs % 24;
                let str = '';
                weeks ? str += weeks + ' week(s) ' : false;
                days ? str += days + ' day(s) ' : false;
                remHrs ? str += remHrs + ' hour(s)' : false;

                this.string = str;
                this.weeks = weeks;
                this.days = days;
                this.hrs = remHrs;
            }

            this.tableData = tableStructure;
            this.refresh = sendRequest;
            this.onUpdateRecord = function (callback) {
                onUpdateRecord = callback;
            };
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/CarrierLoadRatesTableService.js